export class search {
    constructor(
        public id: string,
        public phrase: string,
        public time = Date.UTC
    ) {}
}